import { createColumnHelper } from '@tanstack/react-table';

import { Case, Status } from 'types/items';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Case>();

/**
 * CustomTable's renderStatus special-cased OPEN/CLOSE labels instead of the
 * raw Status enum names ('NEW'/'END' read better than 'OPEN'/'CLOSE' for a
 * case's lifecycle); every other status falls through to the enum label.
 */
export const renderCaseStatus = (status: number) => {
  if (status === 0) {
    return 'NEW';
  }

  if (status === 12) {
    return 'END';
  }

  return Status[status];
};

export const casesColumns = [
  col.accessor((_case) => convertUTCToLocal(_case?.createdAt, true), {
    id: 'createdAt',
    header: 'Created',
    minSize: 140,
  }),
  col.accessor((_case) => _case?.sku?.name || '-', {
    id: 'sku',
    header: 'SKU',
    minSize: 150,
  }),
  col.accessor((_case) => _case?.sku?.itemsInCase || '-', {
    id: 'itemsInCase',
    header: 'Items In Case',
    minSize: 90,
    meta: { align: 'center' },
  }),
  col.accessor((_case) => _case?.sku?.itemType || '-', {
    id: 'itemType',
    header: 'Item Type SKU',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((_case) => _case?.currentPackage || '-', {
    id: 'currentPackage',
    header: 'Package ID',
    minSize: 200,
    size: 320,
    meta: { align: 'center' },
  }),
  col.accessor((_case) => renderCaseStatus(_case?.status), {
    id: 'status',
    header: 'Status',
    minSize: 110,
    meta: { align: 'center' },
  }),
  // Legacy CustomTable rendered `_case?.currentPackage` a second time here
  // (both this and the Package ID column read the same field) rather than
  // a distinct "last assigned package"; preserved verbatim.
  col.accessor((_case) => _case?.currentPackage || '-', {
    id: 'lastAssignedPackage',
    header: 'Last assigned package',
    minSize: 200,
    size: 320,
    meta: { align: 'center' },
  }),
  col.accessor((_case) => _case?.currentVenue?.name || '-', {
    id: 'lastVenue',
    header: 'Last Venue',
    minSize: 150,
    meta: { align: 'center' },
  }),
];
